"use client";

import { cn } from "@/utils/classnames";
import { PropsWithChildren } from "react";

type Props = {
  className?: string;
  applyTheme?: boolean | null;
};

export const NavigationBackground = ({
  className,
  children,
  applyTheme = false,
}: PropsWithChildren<Props>) => {
  return (
    <div
      className={cn(
        "relative h-40 md:h-38",
        {
          "bg-(--theme-color-background-body)": !applyTheme,
          "bg-(--theme-color-background-brand)": applyTheme,
        },
        className
      )}
      data-testid="navigation-background"
    >
      {children}
    </div>
  );
};
